"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.useCasdoor = useCasdoor;

var _vue = require("vue");

var _casdoorJsSdk = _interopRequireDefault(require("casdoor-js-sdk"));

var _token = require("./src/token");

var _CasdoorSDK = _interopRequireDefault(require("./src/CasdoorSDK"));

// Copyright 2022 The casbin Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var _default = _CasdoorSDK["default"];
/**
 * @summary returns the instance of `Sdk`. 
 * @returns {Sdk}
 */

exports["default"] = _default;

function useCasdoor() {
  return (0, _vue.inject)(_token.CASDOOR_SDK_INJECTION_KEY);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/casdoor-vue-sdk/index.js
// module id = lm9p
// module chunks = 9